import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'
import { FindParticipantsPipe } from '../pipe/find-participants.pipe';
import { TranslateServiceService } from '../services/translate-service.service';

@Component({
  selector: 'participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss']
})
export class ParticipantsComponent implements OnInit {

  notCurrentLanguage = "";
  collectorList: any;
  participantsName: any;
  arePageReady: boolean = false;
  text: any = {};

  // Config race
  goalBarBg: string;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService
  ) {
    let _ = this;
    _.getCurrentLanguage();
    _.getQuantities();
  }

  ngOnInit() {
    let _ = this;
    window.scrollTo(0, 0)
  }

  ngAfterViewInit(){
    let _ = this;
    _.getCollectors();
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/participants.translations.json")
      .subscribe((res)=> {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
        }
      });
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');
    console.log(raceName[4])

    return raceName[4];
  }

  getCollectors(){
    let _ = this;
    let conditions = {
      "conditions":{
        "active": true,
        "race_url": _.getRaceName()
      },
      "merchant": _.getMerchant(),
    }
    _.apiService.getTopDonors(conditions).subscribe(data => {
      console.log(data);
      _.collectorList = data['results'];
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
    })
  }

  getQuantities(){
    let _ = this;
    let conditions = {
     "conditions":{
       "race_url": _.getRaceName(),
       "active": true,
     },
      "merchant": _.getMerchant(),
    };
    _.apiService.getQuantities(conditions).subscribe(data => {
      _.goalBarBg = data['results'][0].design.color.secundary;
    })
  }
}
